<!-- 忘记密码 -->
<template>
    <el-dialog @close="close" :visible.sync="centerDialogVisible" width="24%" center>
        <div class="container">
            <div class="title">{{ titleText }}</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item prop="phoneNumber">
                    <el-input placeholder="请输入手机号" v-model="ruleForm.phoneNumber">
                        <el-select style="width: 1rem" v-model="select" slot="prepend" placeholder="请选择">
                            <el-option label="+86" value="1"></el-option>
                        </el-select>
                        <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
                    </el-input>
                </el-form-item>
                <div style="margin-bottom: 0.22rem">
                    <JcRangeVue @success="success" v-if="isShow"></JcRangeVue>
                </div>
                <el-form-item prop="code">
                    <el-input v-model="ruleForm.code" placeholder="请输入验证码" style="width: 2.2rem; margin-right: 0.24rem">
                        <i slot="prefix" class="el-input__icon el-icon-message"></i>
                    </el-input>
                    <el-button style="width: 1.65rem" v-if="!sendMsgDisabled" @click="count">获取验证码</el-button>
                    <el-button style="width: 1.65rem" v-if="sendMsgDisabled">{{
                        time + "秒后获取"
                    }}</el-button>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input :type="type1 ? 'text' : 'password'" v-model="ruleForm.password" placeholder="请输入新密码">
                        <i @click="type1 = !type1" :class="type1 ? 'active' : ''" slot="suffix"
                            class="el-input__icon el-icon-view"></i>
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password1">
                    <el-input :type="type2 ? 'text' : 'password'" v-model="ruleForm.password1"
                        placeholder="请再次输入新密码 (确认密码)">
                        <i @click="type2 = !type2" :class="type2 ? 'active' : ''" slot="suffix"
                            class="el-input__icon el-icon-view"></i>
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')">确认更换新密码并登陆</el-button>
        </span>
    </el-dialog>
</template>

<script>
import JcRangeVue from "./JcRange.vue";
import Api from "@/components/Api/index";
import { mapState } from "vuex";
export default {
    components: { JcRangeVue },
    props: {
        titleText: {
            type: String,
            default: "忘记密码"
        }
    },
    data() {
        const validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            bizId: '',
            isShow: false,
            type1: false,
            type2: false,
            centerDialogVisible: false,
            select: "+86",
            flag: false,
            input: "",
            time: 60, // 发送验证码倒计时
            sendMsgDisabled: false,
            ruleForm: {
                phoneNumber: "", //手机号
                code: "", //验证码
                password: "",
                password1: "", //用来确认二次输入的密码
            },
            rules: {
                phoneNumber: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[3456789]\d{9}$/.test(value) == false) {
                                callback(new Error("请输入正确的手机号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                code: [
                    { required: true, message: "验证码不能为空", trigger: "change" },
                ],
                password: [
                    { required: true, message: "请输入新密码", trigger: "blur" },
                    {
                        min: 6,
                        max: 18,
                        message: "长度在 6 到 18 个字符",
                        trigger: "blur",
                    },
                ],
                password1: [
                    { required: true, message: "请确认新密码", trigger: "blur" },
                    { validator: validatePass2, trigger: "blur", required: true },
                ],
            },
        };
    },
    computed: {
        ...mapState(["userInfor"]),
    },
    watch: {},
    methods: {
        init() {
            this.centerDialogVisible = true;
            this.isShow = true;
        },
        close() {
            this.isShow = this.sendMsgDisabled;
            this.flag = false;
            this.resetForm();
        },
        //滑块成功后
        success() {
            this.flag = true;
        },
        login() {
            new Api('oauth').userLogin({ "username": this.ruleForm.phoneNumber, "password": this.ruleForm.password }).then(res => {
                if (res.status == 200 && res.data.mechanismId != '-10') {
                    this.$store.commit('setAccessToken', res.data.accessToken)
                    this.$store.commit('setRefreshToken', res.data.refreshToken)
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setPlanId', null)
                    this.$store.commit('setCheckIndex', 0)
                    localStorage.setItem('tokenTime', JSON.stringify(res.data.exp * 1000 + Date.now())) //用当前时间加上俩个小时
                }
                else {
                    this.$message({
                        type: "error",
                        message: '账号或密码错误！',
                    });
                }
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let datas = {
                        "bizId": this.bizId,
                        "newPassword": this.ruleForm.password,
                        "userPhone": this.ruleForm.phoneNumber,
                        "verificationCode": this.ruleForm.code,
                    }
                    new Api("user")
                        .updatePassword(datas)
                        .then((res) => {
                            if (res.status == 200) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                if (this.titleText === "修改密码") {
                                    this.login()
                                }
                                this.centerDialogVisible = false
                            } else {
                                this.$message.error(res.statusText);
                            }
                        })

                        .catch(() => {
                            this.$message({
                                type: "error",
                                message: "系统异常!",
                            });
                        });
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs["ruleForm"].resetFields();
        },
        //获取验证码
        getCode() {
            new Api("oauth")
                .sendRegisterCode(this.ruleForm.phoneNumber)
                .then((res) => {
                    if (res.status == 200) {
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        this.bizId = res.data
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "error",
                        message: "系统异常!",
                    });
                });
        },
        count() {
            if (!this.flag) {
                this.$message({
                    message: "请滑动滑块进行校验",
                    type: "warning",
                });
            } else if (/^1[3456789]\d{9}$/.test(this.ruleForm.phoneNumber) == false) {
                this.$message.error("请输入正确的手机号码");
            } else {
                this.getCode();
                const that = this;
                that.sendMsgDisabled = true;
                const interval = window.setInterval(function () {
                    if (that.time-- <= 0) {
                        that.time = 60;
                        that.sendMsgDisabled = false;
                        window.clearInterval(interval);
                    }
                }, 1000);
            }
        },
    },
    created() { },
    mounted() { 
        if(this.userInfor && JSON.stringify(this.userInfor) != '{}'){
            this.ruleForm.phoneNumber = this.userInfor.phoneNumber;
        }
    },
};
</script>
<style lang="scss" scoped>
.container {
    .active {
        color: #cb582e !important;
    }

    .title {
        text-align: center;
        font-size: 0.2rem;
        color: #cb582e;
        margin-bottom: 0.24rem;
    }
}
</style>
